import React from "react";
import "./HTML_MAIN_CSS.css";

const HTML_Website_Examples = () => {
  const examples = [
    {
      title: "Example 1: Basic HTML Page",
      description: "A simple HTML page with a heading, paragraph, and a link.",
      code: `<html>
  <head>
    <title>My First Website</title>
  </head>
  <body>
    <h1>Welcome to My Website</h1>
    <p>This is a simple HTML page.</p>
    <a href="https://www.edutechmasteracademy.com/">Visit Example</a>
  </body>
</html>`,
    },
    {
      title: "Example 2: Adding an Image",
      description: "HTML page with an image and caption.",
      code: `<html>
  <head>
    <title>Image Example</title>
  </head>
  <body>
    <h1>My Favorite Image</h1>
    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTgtM8qd2WiTiXuCoM_qO4aLdZhjHDUebrEpw&s" alt="Placeholder Image" />
    <p>This is a placeholder image.</p>
  </body>
</html>`,
    },
    {
      title: "Example 3: HTML List Example",
      description: "Using ordered and unordered lists.",
      code: `<html>
  <head>
    <title>List Example</title>
  </head>
  <body>
    <h1>Shopping List</h1>
    <ul>
      <li>Fruits</li>
      <li>Vegetables</li>
      <li>Dairy</li>
    </ul>

    <h1>Steps to Cook</h1>
    <ol>
      <li>Wash ingredients</li>
      <li>Chop vegetables</li>
      <li>Cook in pan</li>
    </ol>
  </body>
</html>`,
    },
    {
      title: "Example 4: HTML Table Example",
      description: "Creating a simple table.",
      code: `<html>
  <head>
    <title>Table Example</title>
  </head>
  <body>
    <h1>Student Scores</h1>
    <table border="1">
      <tr>
        <th>Name</th>
        <th>Score</th>
      </tr>
      <tr>
        <td>John</td>
        <td>90</td>
      </tr>
      <tr>
        <td>Jane</td>
        <td>85</td>
      </tr>
    </table>
  </body>
</html>`,
    },
    {
      title: "Example 5: HTML Form Example",
      description: "A simple contact form.",
      code: `<html>
  <head>
    <title>Form Example</title>
  </head>
  <body>
    <h1>Contact Us</h1>
    <form>
      <label for="name">Name:</label>
      <input type="text" id="name" name="name" /><br /><br />
      
      <label for="email">Email:</label>
      <input type="email" id="email" name="email" /><br /><br />
      
      <label for="message">Message:</label><br />
      <textarea id="message" name="message" rows="4" cols="50"></textarea><br /><br />
      
      <input type="submit" value="Submit" />
    </form>
  </body>
</html>`,
    },
    {
      title: "Example 6: HTML Page with Background Color and Styles",
      description: "A page styled with background color and inline CSS.",
      code: `<html>
  <head>
    <title>Styled Page</title>
  </head>
  <body style="background-color: lightblue; font-family: Arial, sans-serif;">
    <h1 style="color: darkblue;">Styled Heading</h1>
    <p style="font-size: 16px;">This page has a light blue background and custom font.</p>
  </body>
</html>`,
    },
  ];

  return (
    <div className="examples-container">
      <h1>HTML Website Examples</h1>
      {examples.map((example, index) => (
        <div key={index} className="example-item">
          <h2>{example.title}</h2>
          <p>{example.description}</p>
          <h3>HTML Code:</h3>
          <pre>
            <code>{example.code}</code>
          </pre>
          <h3>Rendered Output:</h3>
          <iframe
            title={`example-${index}`}
            srcDoc={example.code}
            style={{ width: "100%", height: "300px", border: "1px solid #ccc" }}
          />
          <hr className="divider" />
        </div>
      ))}
    </div>
  );
};

export default HTML_Website_Examples;
